<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-period" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="disabled"
      @input="emit"
      @change="emit"
      @blur="emit"
      id="form-pass-period"
      class="show-tick form-control"
    >
      <option v-for="period in items" v-bind:key="period.id" :value="period.id">{{ period.name }}</option>
    </select>

    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'PeriodCountInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Вид пропуска'
    },

    inputName: {
      default: 'period_count'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  },

  created() {
    if (!this.isView && !this.isDraft && !this.isDuplicate) {
      this.inputValue = Object.keys(this.items)[0]
    }
  },

  watch: {
    items() {
      if (this.inputValue && !this.items[this.inputValue]) {
        this.inputValue = Object.keys(this.items)[0]
      }
    }
  }
}
</script>
